// utils/toProperCase.ts

/**
 * Converts a string to Proper Case (e.g., "john DOE" → "John Doe")
 * @param str - the input string
 * @returns properly capitalized string
 */
export const toAllCaps = (str: string | undefined): string => {
  if (!str) return "";
  return str.toUpperCase();
};
